import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, Lock, ArrowLeft } from "lucide-react";
import { api, setToken, getToken } from "../../lib/auth";
import logoWhite from "../../assets/logo-white-transparent.png";

function formatErr(detail) {
  if (!detail) return "Login failed. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || "").join(" ");
  return String(detail);
}

export const AdminLogin = () => {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => { if (getToken()) nav("/admin"); }, [nav]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setToken(data.access_token);
      toast.success(`Welcome back, ${data.user.name}`);
      nav("/admin");
    } catch (err) {
      toast.error(formatErr(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: "100vh", background: "var(--black)", display: "flex", alignItems: "center",
      justifyContent: "center", padding: 24, position: "relative", overflow: "hidden" }}>
      <div style={{ position: "absolute", top: -120, right: -120, width: 380, height: 380,
        background: "radial-gradient(circle,rgba(242,169,59,0.18),transparent 70%)" }} />
      <div style={{ position: "absolute", bottom: -140, left: -100, width: 360, height: 360,
        background: "radial-gradient(circle,rgba(193,18,31,0.28),transparent 70%)" }} />

      <a href="/" style={{ position: "absolute", top: 26, left: 26, display: "flex", alignItems: "center", gap: 8,
        color: "rgba(255,255,255,0.7)", fontSize: 13, letterSpacing: "0.05em", textTransform: "uppercase" }}
        data-testid="back-to-site">
        <ArrowLeft size={16} /> Back to site
      </a>

      <form onSubmit={submit} data-testid="admin-login-form"
        style={{ position: "relative", zIndex: 1, width: "100%", maxWidth: 420, background: "rgba(255,255,255,0.03)",
          border: "1px solid rgba(255,255,255,0.1)", borderRadius: 22, padding: 42, backdropFilter: "blur(12px)" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 8 }}>
          <img src={logoWhite} alt="VLA" style={{ width: 44, height: 44, objectFit: "contain" }} />
          <span style={{ color: "#fff", fontFamily: "'Bebas Neue'", fontSize: 26, letterSpacing: "0.08em" }}>VLA Admin</span>
        </div>
        <p style={{ color: "rgba(255,255,255,0.6)", fontSize: 14, marginBottom: 28 }}>Sign in to manage your leads.</p>

        <div className="field" style={{ marginBottom: 18 }}>
          <label htmlFor="email" style={{ color: "rgba(255,255,255,0.7)" }}>Email</label>
          <input id="email" data-testid="admin-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
            placeholder="admin@victoriouslions.academy" required
            style={{ background: "rgba(255,255,255,0.06)", color: "#fff", borderColor: "rgba(255,255,255,0.15)" }} />
        </div>
        <div className="field" style={{ marginBottom: 26 }}>
          <label htmlFor="password" style={{ color: "rgba(255,255,255,0.7)" }}>Password</label>
          <input id="password" data-testid="admin-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••" required
            style={{ background: "rgba(255,255,255,0.06)", color: "#fff", borderColor: "rgba(255,255,255,0.15)" }} />
        </div>
        <button type="submit" className="btn btn-gold" data-testid="admin-login-btn" disabled={loading}
          style={{ width: "100%", justifyContent: "center" }}>
          {loading ? <><Loader2 size={17} className="spin" /> Signing in…</> : <><Lock size={16} /> Sign In</>}
        </button>
      </form>
    </div>
  );
};
